import * as styles from "./Textarea.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useControlContext } from "@frontend/contexts";

import type { TextareaProps } from "./Textarea.types";

// No Base UI primitive here: Base UI's Input renders an <input> only, and a
// textarea needs no headless behavior — a styled native element is enough.
export function Textarea({
  size,
  variant,
  invalid,
  success,
  className,
  ...props
}: TextareaProps): JSX.Element {
  const inherited = useControlContext();
  const resolvedSize = size ?? inherited.size;

  return (
    <textarea
      data-slot="textarea"
      className={clsx(
        styles.textarea({ size: resolvedSize, variant, invalid, success }),
        className,
      )}
      aria-invalid={invalid}
      {...props}
    />
  );
}
